// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2y8Dl","content":"Consent_content__2_f5i","footer":"Consent_footer__GuYu3"};